"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalFormComponent = void 0;
const tslib_1 = require("tslib");
const mobx_1 = require("mobx");
const index_1 = require("../../i18n/index");
const mithril_1 = require("../../mithril");
const services_1 = require("../../services");
const input_state_group_1 = require("../input/input.state.group");
const mithril_component_1 = require("../mithril.component");
const modal_service_1 = require("../modal/modal.service");
const notification_service_1 = require("../notification.toast/notification.service");
const spinner_1 = require("../spinner/spinner");
class ModalFormComponent extends mithril_component_1.IMithrilStateComponent {
    constructor(ctx) {
        super();
        this.loading = false;
        this.form = new input_state_group_1.IkeInputStateGroup();
        this.displaySubmitButton = true;
        this.isSubmitButtonDisabled = false;
        this.displayCancelButton = true;
        this.displayCustomButtons = false;
        this.ctx = ctx;
    }
    onCreate() {
        if (this.validate != null) {
            this.autorun(() => { var _a; return (_a = this.validate) === null || _a === void 0 ? void 0 : _a.call(this); });
        }
    }
    open() {
        if (modal_service_1.ModalService.isOpen) {
            return;
        }
        this.reset();
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        modal_service_1.ModalService.open({
            title: this.ctx.title,
            content: () => this.view(),
            actions: () => this.viewActions(),
            onSubmit: () => this.wrapSubmit(),
            canClose: () => this.canClose(),
        }).then(() => this.reset());
    }
    close() {
        this.reset();
        modal_service_1.ModalService.close(false);
    }
    reset() {
        this.form.reset();
        this.loading = false;
    }
    addState(input) {
        this.form.add(input);
    }
    setLoading(loading) {
        this.loading = loading;
    }
    canClose() {
        return !this.loading;
    }
    viewSubmitButton() {
        const confirmContent = typeof this.ctx.confirm === 'function' ? this.ctx.confirm() : this.ctx.confirm;
        const submitChildren = this.loading ? spinner_1.Spinner.view() : (0, index_1.Translate)(confirmContent);
        return (0, mithril_1.m)('button', {
            className: 'mdl-button mdl-button--accent',
            disabled: !this.form.canSubmit || this.loading || this.isSubmitButtonDisabled,
            type: 'submit',
        }, submitChildren);
    }
    viewCancelButton() {
        const cancelContent = typeof this.ctx.cancel === 'function' ? this.ctx.cancel() : this.ctx.cancel;
        const cancelText = cancelContent ? (0, index_1.Translate)(cancelContent) : (0, index_1.Translate)(index_1.T.CANCEL);
        return (0, mithril_1.m)('button', { className: 'mdl-button', onclick: () => this.close(), disabled: this.loading, type: 'button' }, cancelText);
    }
    /**
     * Set custom buttons to display instead of the default Cancel/Submit buttons.
     * Custom buttons will not automatically close the modal, so you must call `this.close()` manually.
     *
     * Note: Needs to be enabled by setting `displayCustomButtons` to true.
     */
    customButtons() {
        return [];
    }
    viewActions() {
        const actionButtons = [];
        if (this.displayCustomButtons) {
            actionButtons.push(...this.customButtons());
        }
        else {
            if (this.displayCancelButton) {
                actionButtons.push(this.viewCancelButton());
            }
            if (this.displaySubmitButton) {
                actionButtons.push(this.viewSubmitButton());
            }
        }
        return mithril_1.m.fragment({}, actionButtons);
    }
    wrapSubmit() {
        if (!this.form.canSubmit) {
            services_1.Logger.error('Attempted to submit invalid form...');
            return false;
        }
        this.setLoading(true);
        return Promise.resolve()
            .then(() => (this.submit != null ? this.submit() : null))
            .then(() => !services_1.Services.License.hasNoLicense && notification_service_1.NotificationService.success(this.ctx.success))
            .then(() => this.close())
            .catch((e) => {
            services_1.Logger.error(e);
            notification_service_1.NotificationService.error({ key: index_1.T.ERROR_GENERAL });
            this.setLoading(false);
            if (this.failToChange != null) {
                this.failToChange(e);
            }
        });
    }
}
exports.ModalFormComponent = ModalFormComponent;
tslib_1.__decorate([
    mobx_1.observable
], ModalFormComponent.prototype, "loading", void 0);
tslib_1.__decorate([
    mobx_1.observable
], ModalFormComponent.prototype, "displaySubmitButton", void 0);
tslib_1.__decorate([
    mobx_1.observable
], ModalFormComponent.prototype, "isSubmitButtonDisabled", void 0);
tslib_1.__decorate([
    mobx_1.observable
], ModalFormComponent.prototype, "displayCancelButton", void 0);
tslib_1.__decorate([
    mobx_1.observable
], ModalFormComponent.prototype, "displayCustomButtons", void 0);
tslib_1.__decorate([
    mobx_1.action
], ModalFormComponent.prototype, "open", null);
tslib_1.__decorate([
    mobx_1.action
], ModalFormComponent.prototype, "close", null);
tslib_1.__decorate([
    mobx_1.action
], ModalFormComponent.prototype, "reset", null);
tslib_1.__decorate([
    mobx_1.action
], ModalFormComponent.prototype, "setLoading", null);
//# sourceMappingURL=modal.form.component.js.map